import React from "react";

const Navbar = ({ fullWidth }) => {
  return (
    <header className="fixed top-0 left-0 w-full z-20">
      <div className={`${fullWidth ? "w-full" : "w-full lg:max-w-[75%]"}`}>
        <div className="bg-white shadow px-5 flex items-center justify-between py-3">
          <img
            src="/Images/name logo.jpg"
            alt="Godrej Varanya Kharghar"
            className="w-30 h-10"
            onClick={() => (window.location.href = "/")}
          />

          <div className="hidden md:flex gap-6 font-medium">
            <a href="#overview" className="hover:text-[#6b8518]">
              Overview
            </a>
            <a href="#price" className="hover:text-[#6b8518]">
              Price
            </a>
            <a href="#amenities" className="hover:text-[#6b8518]">
              Amenities
            </a>
            <a href="#gallary" className="hover:text-[#6b8518]">
              Gallery
            </a>
            <a href="#location" className="hover:text-[#6b8518]">
              Location
            </a>
            <a href="#contact" className="hover:text-[#6b8518]">
              Contact
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
